import { ACTION_QUEUE_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { Layer } from "../../framework/layer/Layer";
export class ReplicatedActionCreator extends Layer {
    constructor(firebase, playerAndGameIdProvider) {
        super([]);
        this.gameIdFirebase = null;
        this.firebase = firebase;
        this.playerAndGameIdProvider = playerAndGameIdProvider;
    }
    createReplicatedAction(className, dataInput) {
        const actionRef = `${ACTION_QUEUE_PATH}/${dataInput.id}`;
        this.gameIdFirebase.set(actionRef, dataInput);
    }
    activate() {
        this.gameIdFirebase = new GameIdFirebaseWrapper(this.firebase, this.playerAndGameIdProvider.data.gameId);
    }
    close() {
    }
    getLayerData() {
        return null;
    }
    update(inEvent) {
        return null;
    }
}
//# sourceMappingURL=ReplicatedActionCreator.js.map